import axios from 'axios';
import { stringify } from 'query-string';

// Utils
import { pushDetalizationAnalytics } from 'utils/analytics/detalization';
import { wait, formatDate } from 'utils/common';

import { API_DATE_FORMAT } from 'constants/common';
import { ANALYTICS_DETAIL } from 'constants/detalization';
import { DETALIZATION_REPORT_ACTIONS } from './constants';

const requestUrl = '/api/profile/detalization/detalizationrequest/';

const dataLayerPush = {
  downloadReport: () => {
    window.dataLayer.push({
      event: 'LK_event',
      LKaction: 'Report Saving',
    });
  },
};

// перенос из Detalization old

const downloadFileByUrl = (url) => {
  const link = document.createElement('a');

  link.href = url;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadFile = async (responseData) => {
  let isDownloadingStopped = false;

  const {
    requestId,
    pollingInterval,
    pollingTimeout,
  } = responseData;

  if (requestId === -1) {
    throw responseData || new Error('Downloading error');
  }

  isDownloadingStopped = false;

  const file = `/api/profile/detalization/detalizationreport/?${stringify({
    requestId,
    unZip: false,
  })}`;

  let counter = 0;

  while (counter < pollingTimeout / pollingInterval) {
    await wait(pollingInterval * 1000);

    try {
      const { data: success } = await axios.get('/api/profile/detalization/requeststatus/', { params: { requestId } });

      if (isDownloadingStopped) {
        return true;
      }

      if (success) {
        downloadFileByUrl(file);

        return success;
      }

      counter += 1;
    } catch (error) {
      throw new Error(error);
    }
  }

  throw new Error('Polling timeout');
};

// DOWNLOAD REPORT ACTIONS
export const downloadDetalizationReportStart = () => ({
  type: DETALIZATION_REPORT_ACTIONS.DOWNLOAD_REPORT,
});

export const downloadDetalizationReportSuccess = () => ({
  type: DETALIZATION_REPORT_ACTIONS.DOWNLOAD_REPORT_SUCCESS,
});

export const downloadDetalizationReportError = () => ({
  type: DETALIZATION_REPORT_ACTIONS.DOWNLOAD_REPORT_ERROR,
});
// SEND REPORT ACTIONS
export const sendDetalizationReportStart = () => ({
  type: DETALIZATION_REPORT_ACTIONS.SEND_REPORT,
});

export const sendDetalizationReportSuccess = () => ({
  type: DETALIZATION_REPORT_ACTIONS.SEND_REPORT_SUCCESS,
});

export const sendDetalizationReportError = () => ({
  type: DETALIZATION_REPORT_ACTIONS.SEND_REPORT_ERROR,
});

// SET PERIOD ACTIONS
export const setDetalizationReportStartPeriod = (payload) => ({
  type: DETALIZATION_REPORT_ACTIONS.SET_PERIOD_START,
  payload,
});

export const setDetalizationReportEndPeriod = (payload) => ({
  type: DETALIZATION_REPORT_ACTIONS.SET_PERIOD_END,
  payload,
});

export const setDetalizationReportInitialState = () => ({
  type: DETALIZATION_REPORT_ACTIONS.SET_INITIAL_STATE,
});

export const downloadDetalizationReport = (reportFormat) => async (dispatch, getState) => {
  const {
    detalizationNew: {
      detalizationReport: {
        startPeriod,
        endPeriod,
      },
    },
  } = getState();

  try {
    dispatch(downloadDetalizationReportStart());

    dataLayerPush.downloadReport();

    const { data } = await axios.post(requestUrl, {
      periodStart: formatDate(startPeriod, API_DATE_FORMAT),
      periodEnd: formatDate(endPeriod, API_DATE_FORMAT),
      reportType: reportFormat,
      isEmailSend: false,
    });

    await downloadFile(data);

    dispatch(downloadDetalizationReportSuccess());

    pushDetalizationAnalytics(ANALYTICS_DETAIL.SUCCESS_DOWNLOAD,
      {
        period: `${startPeriod}-${endPeriod}`,
        format: reportFormat,
      });
  } catch (error) {
    dispatch(downloadDetalizationReportError());
  }
};

export const sendDetalizationReport = (reportFormat) => async (dispatch, getState) => {
  const {
    detalizationNew: {
      detalizationReport: {
        startPeriod,
        endPeriod,
      },
    },
  } = getState();
  try {
    dispatch(sendDetalizationReportStart());

    await axios.post(requestUrl, {
      periodStart: formatDate(startPeriod, API_DATE_FORMAT),
      periodEnd: formatDate(endPeriod, API_DATE_FORMAT),
      reportType: reportFormat,
      isEmailSend: true,
    });

    dispatch(sendDetalizationReportSuccess());

    pushDetalizationAnalytics(ANALYTICS_DETAIL.SUCCESS_MAIL_SEND,
      {
        period: `${startPeriod}-${endPeriod}`,
        format: reportFormat,
      });
  } catch (error) {
    dispatch(sendDetalizationReportError());
  }
};
